module.exports = __webpack_public_path__ + "img/initial-fetch-error-image.a855a786.webp";